// A filter field counts as set once it holds something to filter by: an empty
// multi-select ([]) or a cleared input ('') is not a filter.
export const isFilterValueSet = (value: unknown): boolean =>
  Array.isArray(value)
    ? value.length > 0
    : value !== undefined && value !== null && value !== '';

// True when any field of a filter form is set — gates Clear All and Apply.
export const hasFilterValue = (values?: Record<string, unknown> | null) =>
  !!values && Object.values(values).some(isFilterValueSet);
